import {useMutation} from "@tanstack/react-query";
import {UploadGtaConfigRequest} from "@/Stub/V1";
import {processValidationErrors} from "@/Util/Api/processValidationErrors";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export const useUploadGtaRateConfig = () => useMutation({
    mutationFn: async (data: UploadGtaConfigRequest) => {
        try {
            return await GtaRatesApiClient.uploadGtaConfig(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});
